<template>
	<div class="home-intro pt-60">
		<h2 class="member-t">全程陪伴<span class="font-red">服务体系</span></h2>
		<p class="member-p font-red">全程护航，助力寄售行数字化转型成功</p>
		<div class="service-row quick_wrap-row">
			<div class="service-row-l">
				<img src="../../static/home/service-row1.png" alt="" />
			</div>
			<div class="service-row-r">
				<div class="flex mb-20">
					<img class="service-row-img mr-20" src="../../static/home/service-row2.png" alt="" />
					<img class="service-row-img" src="../../static/home/service-row3.png" alt="" />
				</div>
				<div class="flex">
					<img class="service-row-img mr-20" src="../../static/home/service-row4.png" alt="" />
					<img class="service-row-img" src="../../static/home/service-row5.png" alt="" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			
		},
		data() {
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped>
.home-intro {
	background-color: #fff;
}	
.member-t {
	font-weight: 600;
	font-size: 40px;
	color: #333333;
	text-align: center;
}
.member-p {
	font-weight: 600;
	font-size: 14px;
	color: #999999;
	margin-bottom: 80px;
	text-align: center;
}
.quick_wrap-row {
	width: 1200px;
	margin: 0 auto;
}
.service-row {
	display: flex;
	align-items: center;
	cursor: pointer;
}
.service-row-l {
	width: 360px;
	margin-right: 20px;
}
.service-row-l img {
	width: 360px;
	height: 500px;
	vertical-align: middle;
	border-radius: 15px;
	transition: transform 0.3s ease; 
}
.service-row-l img:hover {
	transform: scale(1.04);
	box-shadow: 0 10px 15px rgba(170,69,67,0.1);
}
.service-row-r {
	flex: 1;
}
.service-row-r .service-row-img {
	width: 400px;
	height: 240px;
	vertical-align: middle;
	border-radius: 15px;
	transition: transform 0.3s ease; 
}
.service-row-r .service-row-img:hover {
	transform: scale(1.04);
	box-shadow: 0 10px 15px rgba(170,69,67,0.1);
}
</style>


// WEBPACK FOOTER //
// src/components/Service.vue